import { ServiceDefinition } from '@pershing/pershing-core';

export class NXIGridExportServiceDefinition implements ServiceDefinition {
    private static instance: ServiceDefinition = null;

    family = 'netxinvestor';
    appName = 'export-svc';
    serviceName = 'app';
    uri = 'export';
    version = 'v1';
    mnemonic = 'nxp';

    static getInstance(): ServiceDefinition {
        if (!NXIGridExportServiceDefinition.instance) {
            NXIGridExportServiceDefinition.instance = new NXIGridExportServiceDefinition();
        }
        return NXIGridExportServiceDefinition.instance;
    }
}
